<template>
<div>
    <app-header></app-header>
    <div class="container-fluid">
      <div class="row my-3">
        <div class="col-lg-1 col-md-12">
        <button type="button" style="font-size: 16px" class="btn btn-outline-primary btn mr-3" @click="backToProjects()"><i class="fas fa-chevron-left mr-2"></i>Back</button>
        </div>
        <div class="col-lg-4 col-md-12">
        <input type="text" style="font-size: 16px" class="input form-control" v-model="searchuser"/>
        </div>
        
        </div>
        <div><h1>Users({{userlist().length}})</h1></div>
        <hr/>
        <div v-for="u in userlist()" v-bind:key="u.userId">
            <div class="row my-1">
                <div class="col-lg-4 col-md-12">
                    <span :class="u.role != 3 ? 'badge badge-primary mr-3' : 'badge badge-danger mr-3'">{{u.role}}</span><strong>{{u.companyName}}</strong>, {{u.country}}
                </div>
                <div class="col-lg-2 col-md-12 small">
                    {{u.firstName}} {{u.lastName}}
                </div>
                <div class="col-lg-1 col-md-12">
                    <span :class="u.systemCompany == 1 ? 'badge badge-pill badge-primary mr-3' : 'badge badge-pill badge-warning mr-3'">{{sysco(u.systemCompany)}}</span>
                </div>
                <div class="col-lg-1 col-md-12 small">
                    {{u.language}}
                </div>
                <div class="col-lg-2 col-md-12 small mb-1">
                    {{u.email}}
                </div>
                <div v-if="role == 1 || role == 4 || role == 5 || role == 6" class="col-lg-2 col-md-12 text-lg-right">
                <span :class="u.role != 3 ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-danger'" @click="EditUser(u.userId)">Edit</span>
                <!--span :class="u.role != 3 ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-danger'" @click="ProjectList(u.userId)">Projects</span-->
              </div>
            </div>
            <hr/>
        </div>
        <a id="back-to-top" href="#" class="btn btn-primary btn-lg back-to-top" role="button"><i class="fas fa-chevron-up mr-2"></i>Top</a>
    </div>
</div>
</template>

<script>
import AppHeader from "../intro/AppHeader";
import store from '../../ClientApp/store';
import { mapGetters } from "vuex";

export default {
  data: function () {
    return {
      error: null,
      usersloaded: false,
      searchuser: "",
      users: null
    };
  },
  components: {
    AppHeader
  },
  computed: {
      role(){
      return this.$store.state.auth.role;
      },
      ...mapGetters(['getSysco'])
  },
  methods:{
      EditUser(id){
          this.$router.push("/edituser/" + id);
      },
      sysco(s){
      let sc = this.getSysco.find(o => o.code == s);
      return sc.desc;
      },
      backToProjects(){
        this.$router.push("/projects/0");
      },
      userlist(){
        var u = this.$store.getters.getUserlist;
        if (u != null){
          return u.filter(f => f.firstName.toUpperCase().concat(f.lastName.toUpperCase()).concat(f.companyName.toUpperCase()).concat(f.role.toString()).includes(this.searchuser.toUpperCase()));
        }
        else
          return u;
      },
      ProjectList(id){
        this.$router.push("/projects/" + id)
      }
  },
  
  beforeCreate() {
    this.$store.dispatch("getUsers")
    .then(response => {
      this.usersloaded = true;
    });
  },

  mounted(){
    $(document).ready(function(){
     $(window).scroll(function () {
            if ($(this).scrollTop() > 50) {
                $('#back-to-top').show();
            } else {
                $('#back-to-top').hide();
            }
        });
        // scroll body to 0px on click
        $('#back-to-top').click(function () {
            $('#back-to-top').tooltip('hide');
            $('body,html').animate({
                scrollTop: 0
            }, 800);
            return false;
        });
        
        $('#back-to-top').tooltip('show');

});
  }
  
}
</script>

<style scoped>
    @media (min-width: 1500px) {
        .container-fluid {
        width: 80%;
        }
    }
    @media (min-width: 2000px) {
        .container-fluid {
        width: 60%;
        }
    }
    

    .lnk{
      cursor:pointer;
    }

    .back-to-top {
        cursor: pointer;
        position: fixed;
        bottom: 20px;
        right: 20px;
        display:none;
    }
</style>


// WEBPACK FOOTER //
// src/components/users/UserList.vue